import { render, staticRenderFns } from "./AccessForbiddenPage.vue?vue&type=template&id=cdf721b8&scoped=true&"
var script = {}
import style0 from "./AccessForbiddenPage.vue?vue&type=style&index=0&id=cdf721b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf721b8",
  null
  
)

export default component.exports